<template>
  <span :key="index">
    {{ value }}
  </span>
</template>

<script>
import HardwordMixins from "@/mixins/Hardword";
export default {
  mixins: [HardwordMixins],
  props: {
    value: String
  },
  data: () => ({
    index: 0
  }),
  watch: {
    value() {
      this.rerender();
    }
  },
  methods: {
    rerender() {
      this.index++;
    }
  }
};
</script>